import React from 'react'
import Hero from '../../Components/Hero/Hero'
import Choose from '../../Components/Choose/Choose'
import Testimonial from '../../Components/Testimonial/Testimonial'
import Service from '../../Components/Service/Service'

function Home() {
  return (
    <div>
      <Hero />   
      <Choose />
      <Service />  
      <Testimonial />
    </div>
  )
}

export default Home